


<div class="controller-card" id="container" style="margin: 0 auto;
  overflow: hidden;">
    <button class="close-button" (click)="modalClose()">✕</button>
  
    <header class="controller-header mt-4">
      <div class="controller-avatar">
        <img src="assets/img/sidepanel-controller-icon.svg" alt="Controller Icon" class="mb-4"/>
      </div>
      <h2>{{controllerDetails.controller_tag}}</h2>
    </header>


  
    <div class="controller-info" [class.hidden-box]="isHidden">
      <div class="info-row">
        <img src="assets/img/Vector2.png" alt="Model Icon" />
        <div class="info-text">
          <p class="value">{{controller_info?.controller_model_number}}</p>
          <span class="label">MODEL NUMBER</span>
        </div>
      </div>
  
      <hr />
  
      <div class="info-row">
        <img src="assets/img/Group 289709.svg" alt="Serial Icon" />
        <div class="info-text">
          <p class="value">{{controller_info?.controller_serial_number}}</p>
          <span class="label">SERIAL NUMBER</span>
        </div>
      </div>
  
      <hr />
  
      <div class="info-row">
        <img src="assets/img/Vector 1.png" alt="Date Icon" />
        <div class="info-text">
          <p class="value">{{controller_info?.installed_date |date:'MMMM d, y' | uppercase }} </p>
          <span class="label">INSTALLED DATE</span>
        </div>
      </div>
  
    </div>
  
    <div class="controller-actions" [class.hidden-box]="isHidden" *ngIf="!spinner">
      <img src="assets/img/reboot-button.svg" alt="" (click)="rebootController()" width="100">
    </div>
  </div>
  <div *ngIf="spinner" class="text-center" >
    <div class="spinner-border text-primary" role="status"></div>
    
  </div>
  <p *ngIf="onSubmit" class="reboot-message-div">{{rebootMessage}}</p>
  